import React,{useState} from "react";
import User from "../../assets/data/user.js";
import Delete from "../../components/admin/popup/Delete/Delete";


function NewAdd() {
  const TotalUser = User.length;
  const [showDelete, setShowDelete] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setShowDelete(true);
  };

  const handleDeleteConfirm = () => {
    console.log(`Deleting user: ${userToDelete.name}`);
    setShowDelete(false);
  };

  const handleDeleteCancel = () => {
    setShowDelete(false);
  };

  return (
    <div className="MainDashboard flex items-center justify-between">
      <div className="Table w-[100%] rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold mb-2">New Users</h2>
          <div className="relative">
            <i
              className="fa fa-bell text-[24px] relative"
              aria-hidden="true"
            ></i>
            {TotalUser > 0 && (
              <span className="absolute top-[-5px] right-[-5px] bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {TotalUser}
              </span>
            )}
          </div>
        </div>

        {/* Table Container with Scroll */}
        <div className="overflow-y-auto h-[70vh] lg:w-full md:full w-[330px]">
          <table className="lg:w-full md:full w-[350px] border-collapse text-sm">
            <thead className="sticky top-0 bg-gray-200">
              <tr className="text-gray-700">
                <th className="p-2 border-b">Name</th>
                <th className="p-2 border-b">Phone</th>
                <th className="p-2 border-b">Address</th>
                <th className="p-2 border-b">Profile</th>
                <th className="p-2 border-b">Action</th>
              </tr>
            </thead>
            <tbody>
              {User.map((user) => (
                <tr className="hover:bg-gray-100" key={user._id}>
                  <td className="p-2 border-b text-center">{user.Name}</td>
                  <td className="p-2 border-b text-center">{user.phone}</td>
                  <td className="p-2 border-b text-center">{user.address}</td>
                  <td className="p-2 border-b items-center justify-center flex">
                    <img
                      src={user.image}
                      alt="ProfilePhoto"
                      className="w-8 h-8 rounded-full"
                    />
                  </td>
                  <td className="p-2 border-b text-center">
                    <i
                      className="fa fa-trash text-red-600 hover:text-red-800 cursor-pointer"
                      aria-hidden="true"
                      onClick={() => handleDeleteClick(user)}

                    ></i>
                    <i
                      className="fa fa-edit text-primary hover:text-primary/90 cursor-pointer ml-2"
                      aria-hidden="true"
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
{/* Popup Modal */}
 {showDelete && userToDelete &&  (
  <Delete
    image={userToDelete.image}
    name={userToDelete.Name}
    onDelete={handleDeleteConfirm}
    onCancel={handleDeleteCancel}
  /> 
)}
    </div>
  );
}

export default NewAdd;
